var _defs, _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew268({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 4,
    cy: 8,
    r: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 4,
    cy: 8,
    r: 0.61
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.9,9.29V6.52H9.05V6.15h2v.37h-.85V9.29Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.43,9.29V6.15h.89a1.57,1.57,0,0,1,.5.06.86.86,0,0,1,.39.27,1.44,1.44,0,0,1,.26.51,2.53,2.53,0,0,1,.09.72,2.42,2.42,0,0,1-.15.9,1.09,1.09,0,0,1-.41.53,1.21,1.21,0,0,1-.64.15Zm.34-.37h.55a1,1,0,0,0,.5-.1.69.69,0,0,0,.27-.35,2.22,2.22,0,0,0,.12-.77A1.71,1.71,0,0,0,13.08,7a.76.76,0,0,0-.33-.37,1.22,1.22,0,0,0-.44-.06h-.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew268);
export default __webpack_public_path__ + "static/media/Symbolpack_New_268.bc571be35a9cd1332cc3903f14805599.svg";
export { ForwardRef as ReactComponent };